import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../contexts/UserContext.js';
import { getAvailableLocations } from '../../../hooks/unitDataHooks.js';
import { getUnitStateListener,  getUnitDataListener} from '../../../hooks/unitDataHooks.js';
import { useTranslation } from 'react-i18next';
import { getDisplayDateFromTimestamp } from '../../../common/dateTools.js';

import "./ScreenMonitoringPage.css";
import { use } from 'react';
import { useLatestScreenshot } from '../../../contexts/LatestScreenshotContext.js';
import { getActiveUnitIdsForLocation } from '../../../common/displayUnitRanges.js';

const ScreenMonitoringPage = () => {
    const { t } = useTranslation();
    const [locations, setLocations] = useState([]);
    const [locationUnits, setLocationUnits] = useState([]);
    const [evaluations, setEvaluations] = useState([]);
    const [unitRecentDataModels, setUnitRecentDataModels] = useState([]);
    const [lastScreenshotTimestampForUnit, setLastScreenshotTimestampForUnit] = useState({});
    const { userData } = useUser();
    
    const [statesForUnit, setStatesForLocation] = useState({});
    const [recordForUnit, setRecordForLocation] = useState({});
    const navigate = useNavigate();
    const {
        loadLatestScreenshotsForUnits,
        latestScreenshotCards
    } = useLatestScreenshot();

    const navigateToLocation = useCallback((locationId) => {
        //console.log("navigateToLocation")
        navigate(`/locations/${locationId}`)
    }, [navigate])

    const navigateToUnit = useCallback((locationId, unitId) => {
        navigate(`/locations/${locationId}/unit/${unitId}/dashboard`);
    }, [navigate])

    const specialTranslation = {
        "default": {
            "Normal": "Normalt træ"
        }
    }

    const getSpecialTranslation = (string, unit) => {
        if (specialTranslation[unit]) {
            if (specialTranslation[unit][string]) {
                return specialTranslation[unit][string]
            }
        } else {
            if (specialTranslation["default"][string]) {
                return specialTranslation["default"][string]
            }
        }

        return string
    }

    const getColorForUnit = (unitId) => {
        if (unitId && statesForUnit[unitId]) {
            const state = statesForUnit[unitId].worstState;
            switch (state) {
                case 'Ready':
                    return 'var(--success-500)';
                case 'Error':
                    return 'var(--error-500)';
                case 'Warning':
                    return 'var(--warning-500)';
                default:
                    return 'var(--gray-500)';
            }
        }
    }

    useEffect(() => {
        var unsubscribeCallbacks = []
        if (locations) {
            for (let i = 0; i < locations.length; i++) {
                if (!locations[i]) {
                    continue;
                }
                const unitIds = getActiveUnitIdsForLocation(locations[i]);
                for (let j = 0; j < unitIds.length; j++) {
                    const unitId = unitIds[j];
                    const unsubscribeFirestore = getUnitStateListener(unitId, {
                        next: (log) => {
                            setStatesForLocation((prevStates) => {
                                
                                const locationId = locations[i].id;
                                let unitStatus;
                        
                                unitStatus = {
                                    newestTimestamp: log.timestamp,
                                    worstState: log.state,
                                };
                                
                                if (unitStatus.newestTimestamp < new Date(Date.now() - 1 * 60 * 60 * 1000)) {
                                    unitStatus.worstState = 'Disconnected';
                                }
                        
                                const newValue = { ...prevStates, [unitId]: unitStatus };
                                return newValue;
                            });
                        },
                        error: (error) => {
                            console.error("Error in unit state listener:", error);
                        }
                    });
                    unsubscribeCallbacks.push(unsubscribeFirestore)

                    const unsubscribeUnitDataListener = getUnitDataListener(unitId, {
                        next: (unit_data) => {
                            
                            if (unit_data.last_screenshot_timestamp) {
                                const timestampChanged = !lastScreenshotTimestampForUnit[unitId] || unit_data.last_screenshot_timestamp > lastScreenshotTimestampForUnit[unitId]
                                if (timestampChanged) {
                                    loadLatestScreenshotsForUnits([{ location: locations[i], unit: unitId }]);

                                    setLastScreenshotTimestampForUnit((prevValue) => {
                                        const newValue = { ...prevValue, [unitId]: unit_data.last_screenshot_timestamp };
                                        return newValue;
                                    });
                                }
                            }
                        },
                        error: (error) => {
                            console.error("Error in unit data listener:", error);
                        }
                    });
                    unsubscribeCallbacks.push(unsubscribeUnitDataListener);
                }
            }
        }

        return () => {
            for (let i = 0; i < unsubscribeCallbacks.length; i++) {
                unsubscribeCallbacks[i]();
            }
        }
    }, [locations]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                if (userData && userData.companies) {
                    const locations = await getAvailableLocations(userData);
                    setLocations(locations);
                }
            } catch (error) {
                console.error("Error fetching locations: ", error);
            }
        };

        fetchData();
    }, [userData]);

    useEffect(() => {
        if (locations) {
            const newLocationUnits = []
            const evaluationsNewValue = []
            for (let location in locations) {
                let evaluations = []

                const unitIds = getActiveUnitIdsForLocation(locations[location]);
                for (let unitKey in unitIds) {
                    const unit = unitIds[unitKey]
                    evaluations.push(0)

                    const locationUnit = {
                        location: locations[location],
                        unit: unit,
                    }

                    newLocationUnits.push(locationUnit)
                }
                
                evaluationsNewValue.push(evaluations)
            }

            setLocationUnits(newLocationUnits)
            setEvaluations(evaluationsNewValue)
        }
    }, [locations]);


    useEffect(() => {
        console.log("useEffect - locationUnits", locationUnits)
        
        //loadLatestScreenshotsForUnits(locationUnits);
    }, [locationUnits]);
    
    return (
        <div className="ScreenMonitoringPage">
            <div className="wrapper">
                {latestScreenshotCards.map((latestImageCard, index) => (
                    <div key={index} className="card-wrapper" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <div 
                            className="login-container card-container" 
                            style={{ width: '100%', maxWidth: '620px' }}
                            onClick={() => {
                                    //navigateToUnit(locations[index].id, latestImageCard.unit)
                                }
                            }
                        >
                            <div className="card-header">
                                <div className="card-header-title">
                                    {/*locations[index].name} - {units[index].name}*/}
                                    {latestImageCard.location.name} - {latestImageCard.unit}
                                </div>
                            </div>
                            <div className="card-body" style={{ marginBottom: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                                <figure className="img-wrapper">
                                    <img 
                                        className="poster-image"
                                        src={latestImageCard.screenshotUrl}
                                        width="588"
                                        height="250"
                                        alt="Poster"
                                    />
                                </figure>
                            </div>
                            <div className="card-body location-bar" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                                <div className="location-bar-left">
                                    <div className="date-line">
                                        {getDisplayDateFromTimestamp(latestImageCard.timestamp, 'da')}
                                    </div>
                                </div>
                                <div className="location-bar-right">
                                    <div className="live-activity-wrapper">
                                        <div className="live-activity-dot" style={{ backgroundColor: getColorForUnit(latestImageCard.unit) }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ScreenMonitoringPage;